import { getSpacing } from "@faire/web--source/slate/spacing";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import { trackSeoFeaturedBrandsOnCategoryPageCtaClick } from "@faire/web-api--source/events/seo/click/featuredBrandsOnCategoryPageCta";
import React from "react";
import styled from "styled-components";

import { BrandReviewsCarousel } from "@faire/retailer/components/SearchProducts/BrandReviewsCarousel";
import { categoryPath } from "@faire/retailer/paths/category/categoryPath";
import { suppliersPath } from "@faire/retailer/paths/suppliers/suppliersPath";
import { useRetailerRoutingContext } from "@faire/retailer/RetailerRoutingContextProvider";
import { useLoggedOutCategoryPageCurrentCategory } from "@faire/retailer/views/category/__internal__/CategoryPageRoot/__internal__/LoggedOutCategoryPage/__internal__/Context/useLoggedOutCategoryPageCurrentCategory";
import { useLoggedOutCategoryPageBrandTileReviewsResponse } from "@faire/retailer/views/category/__internal__/CategoryPageRoot/__internal__/LoggedOutCategoryPage/__internal__/DataFetching/useLoggedOutCategoryPageBrandTileReviewsResponse";
import { useLoggedOutCategoryPageCatNavResponse } from "@faire/retailer/views/category/__internal__/CategoryPageRoot/__internal__/LoggedOutCategoryPage/__internal__/DataFetching/useLoggedOutCategoryPageCatNav/useLoggedOutCategoryPageCatNavResponse";

export const LoggedOutCategoryPageBrandReviewsCarousel: React.FC = () => {
  const categoryModel = useLoggedOutCategoryPageCurrentCategory();
  const routingContext = useRetailerRoutingContext();
  const brandPageQueryParameters =
    useLoggedOutCategoryPageCatNavResponse().data.brandPageQueryParams;
  const brands = useLoggedOutCategoryPageBrandTileReviewsResponse();
  if (!brands?.length) {
    return null;
  }
  return (
    <BrandReviewsCarouselWrapper data-test-id="logged-out-category-page-featured-brands">
      <BrandReviewsCarousel
        brands={brands}
        brandPageQueryParams={brandPageQueryParameters}
        ctaLink={
          categoryModel?.isSuppliersPageCategoryValid
            ? suppliersPath({ urlIds: categoryModel.urlIds, routingContext })
            : categoryPath({ urlIds: categoryModel.urlIds, routingContext })
        }
        onCtaClick={() =>
          trackSeoFeaturedBrandsOnCategoryPageCtaClick(
            categoryModel.pathIdentifier ?? ""
          )
        }
      />
    </BrandReviewsCarouselWrapper>
  );
};

const BrandReviewsCarouselWrapper = styled.div`
  margin: 0;

  ${responsiveMediaQueries.mobile} {
    margin: ${getSpacing(0, 12)};
  }

  ${responsiveMediaQueries.tablet} {
    margin-right: ${getSpacing(1)};
    margin-left: ${getSpacing(1)};
  }
`;
